import React from 'react';

const HorizontalDivider = () => (
  <div style={{ height: '3.5rem', display: 'flex', alignItems: 'center' }}>
    <hr style={{ borderStyle: 'inset', width: '100%' }} />
  </div>
);

export default HorizontalDivider;
